import Grid from "@mui/material/Grid";

import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
export default function WmsHead({
  fDocNo_Input,
  fDocNo,
  fLocation_MultiSelect,
  sLocationData,

  fParty_MultiSelect,
  sPartyData,
  fCluster_MultiSelect,
  sClusterData,

  //multiselect
  sWebTransDetailReportData,
  sWebBetweenReportArr,

  sTransactionData,
  fTransaction_MultiSelect,

  sDocTypeData,
  fDocType_MultiSelect,

  HeadObject,
  fLocation,
  fParty,
  fCluster,
  fTransaction,
  fDocType,

  fFromDate,
  fToDate,
  fDate,

  //item name
  fItem,
  fItemName_onKeyUp,
  fItemName,
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
}) {
  return (
    <form id="TransDetailReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center "
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Trans Detail Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDate"
                xValue={HeadObject.sDate}
                xOnChange={fDate}
                xName={"sDate"}
                xData={sWebBetweenReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Loc/Party"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sParty"
                xValue={HeadObject.sParty}
                xOnChange={fParty}
                xName={"sParty"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sPartyData}
                xDisabled={
                  HeadObject?.sParty?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sPartyArr}
                setValue={fParty_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Document"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"22"}
                xLabelText="sDocType"
                xValue={HeadObject.sDocType}
                xOnChange={fDocType}
                xName={"sDocType"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sDocTypeData}
                xDisabled={
                  HeadObject?.sDocType?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sDocTypeArr}
                setValue={fDocType_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Transaction"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sTransaction"
                xValue={HeadObject.sTransaction}
                xOnChange={fTransaction}
                xName={"sTransaction"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sTransactionData}
                xDisabled={
                  HeadObject?.sTransaction?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                xValue={HeadObject.sTransactionArr}
                setValue={fTransaction_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Cluster"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sCluster"
                xValue={HeadObject.sCluster}
                xOnChange={fCluster}
                xName={"sCluster"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sClusterData}
                xDisabled={
                  HeadObject?.sCluster?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sClusterArr}
                setValue={fCluster_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Doc.No"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDocNo"
                xValue={HeadObject.sDocNo}
                xOnChange={fDocNo}
                xName={"sDocNo"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <CmpInputField
                xtabIndex={"02"}
                xValue={HeadObject.sDocNo_Input}
                xType={"number"} // text/number/password
                xName={"sDocNo_Input"}
                xReadOnly={
                  HeadObject?.sDocNo?.toUpperCase() === "ALL" ? true : false
                }
                xOnChange={fDocNo_Input}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Item"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"14"}
                xLabelText="sItem"
                xValue={HeadObject.sItem}
                xOnChange={fItem}
                xName={"sItem"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <CmpInputField
                xValue={HeadObject.sItemCode}
                xType={"text"} // text/number/password
                xName={"sItemCode"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <GCToggleSearch
                xtabIndex={"15"}
                xName={"sItemName"}
                xType={"text"}
                xValue={HeadObject?.sItemName}
                xReadOnly={
                  HeadObject?.sItem?.toUpperCase() === "ALL" ? true : false
                }
                xOnChange={fItemName}
                xOnKeyUp={fItemName_onKeyUp}
                xError={false}
                xErrorMessage={""}
                xMediaQuery={xMediaQuery}
                xonClickbtn={xonClickbtn}
                xrows={xrows}
                xcolumns={xcolumns} //head
                xRowCellClick={xRowCellClick}
                xRowClick={xRowClick}
                xToggle={xToggle}
                xData={xData}
                xOnChangeDropdownInput={xOnChangeDropdownInput}
                xDropdownObj={xDropdownObj}
                xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebTransDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
